import React, { Component } from 'react';
import { connect } from 'react-redux';
// import { openModal } from '../redux/actions/modalAction';
import {
  openEditNotificationModal,
  setNotificationType,
} from '../redux/actions/alertModalActions';

export function withTrekEditInfo(EditableComponent) {
  const mapDispatchToProps = dispatch => {
    return {
      openModal: ({ message }) => {
        // dispatch(openModal());
        dispatch(openEditNotificationModal());
        dispatch(setNotificationType({ notificationType: message }));
      },
    };
  };

  class EditableComponentWithInfo extends Component {
    render() {
      const edit = this.setPrivilege();
      return <EditableComponent {...this.props} edit={edit} />;
    }

    setPrivilege = () => {
      const {
        isLoggedIn,
        isTemplate,
        isOwner,
        openModal,
        editable,
        modalType,
      } = this.props;
      let edit = '';
      let editFunction = '';

      const editCard = editable && editable.edit;
      const isAdded = editable && editable.isAdded;
      const isLoading = editable && editable.isLoading;

      var editForType = {
        trekDayEdit: () => editCard,
        trekDayModal: () => null,
        trekDaySummary: () => null,
      };
      editFunction = modalType && editForType[modalType]();

      var privilege = {
        isLoggedIn: {
          isTemplate: {
            isOwner: () => editFunction,
            isNotOwner: () => openModal,
          },
          isNotTemplate: {
            isOwner: () => editFunction,
            isNotOwner: () => openModal,
          },
        },
        isNotLoggedIn: {
          isTemplate: () => openModal,
          isNotTemplate: () => openModal,
        },
      };

      edit = isLoggedIn
        ? isTemplate
          ? isOwner
            ? {
                edit: privilege['isLoggedIn']['isTemplate']['isOwner'](),
              }
            : {
                edit: privilege['isLoggedIn']['isTemplate']['isNotOwner'](),
                message: '1L-1T-0O',
              }
          : isOwner
          ? {
              edit: privilege['isLoggedIn']['isNotTemplate']['isOwner'](),
            }
          : {
              edit: privilege['isLoggedIn']['isNotTemplate']['isNotOwner'](),
              message: '1L-0T-0O',
            }
        : isTemplate
        ? {
            edit: privilege['isNotLoggedIn']['isTemplate'](),
            message: '0L-1T',
          }
        : {
            edit: privilege['isNotLoggedIn']['isNotTemplate'](),
            message: '0L-0T',
          };

      return {
        ...edit,
        isAdded,
        isLoading,
      };
    };
  }

  return connect(
    null,
    mapDispatchToProps
  )(EditableComponentWithInfo);
}



// WEBPACK FOOTER //
// ./src/HOCs/withTrekEditInfo.jsx